import { Flex, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { DisplayValue } from './mls-info.types';

export const DataField: FC<{
  label: string;
  value: DisplayValue;
}> = ({ label, value }) => {
  const displayValue =
    value === undefined || value === null || String(value).trim() === ''
      ? '-'
      : String(value);
  const valueColor = displayValue === '-' ? 'whiteAlpha.500' : 'inherit';

  return (
    <Flex
      alignContent="flex-start"
      alignItems="center"
      borderBottom="1px solid"
      borderColor="whiteAlpha.200"
      direction="row"
      justifyContent="space-between"
      py={{ base: 2, md: 4 }}
    >
      <Text color="whiteAlpha.700">{label}:</Text>
      <Text color={valueColor} flexGrow={1} fontWeight="medium" mx={2}>
        {displayValue}
      </Text>
    </Flex>
  );
};
